<template>
  <div>
    <DoRight
      ref="right"
      :limitTime="limitTime"
      :reportId="reportId"
      :scantron="scantron"
      :hasSection="hasSection"
      :answer="answer"
      :hasNotSupport="false"
      :shotAnswerEditable="shotAnswerEditable"
      :current="current"
      :getTopicFunc="onGetTopic"
      :submitTopicFunc="onSubmitTopic"
      @submit="onSubmit"
    ></DoRight>
    <LimitModal v-model="visible" :questionType="$route.query.examType" />
  </div>
</template>
<script>
import DoRight from '@/components/ques/DoRight.vue';

export default {
  name: 'ExamDoRight',
  components: {
    DoRight,
  },
  props: {
    limitTime: {
      type: Number,
      default: 0,
    },
    shotAnswerEditable: {},
    reportId: {},
    scantron: {
      type: Object,
      default: () => {
        return {};
      },
    },
    hasSection: {
      type: Boolean,
      default: false,
    },
    answerImg: {
      type: Object,
      default: () => {
        return {};
      },
    },
    answer: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      current: {},
      visible: false,
      index: '',
      is_confirm: 0,
    };
  },
  computed: {
    total() {
      return this.scantronQuestions.length;
    },
    answerCount() {
      return this.scantronQuestions.filter((q) => q.status == 1 || q.status == 2).length;
    },
    scantronQuestions() {
      if (!this.scantron.list) {
        return [];
      }
      if (this.hasSection) {
        let list = [];
        this.scantron.list.forEach((t) => {
          t.child.forEach((ques) => {
            list.push(ques);
          });
        });
        return list;
      } else {
        return this.scantron.list;
      }
    },
  },
  watch: {
    '$store.state.showQuestionAnswer': {
      handler(val) {
        this.is_confirm = val;
        if (val.is_confirm && val.get) this.$refs['right'].submitTopic();
      },
      deep: true,
    },
  },
  methods: {
    init(index, seconds) {
      this.$refs.right.init(index, seconds);
    },
    onGetTopic({ reportId, index }) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        //判断是不是额度用完
        let data = await this.$http.get('/api/app/practice/question/' + reportId, { page: index });
        if (data.code == 203) {
          this.visible = true;
          // eslint-disable-next-line vue/no-mutating-props
          this.reportId = reportId;
          this.question_id = data.data.error[0].question_id;
          this.index = index;

          this.$store.commit('setShowQuestionAnswer', {
            is_confirm: data.data.error[0].is_confirm,
            get: false,
          });

          this.getQuestionData({
            getAnswer:
              this.$store.state.questionModeSelect == 2 && data.data.error[0].is_confirm == 1,
            data: {
              ...data.data,
              list: [{ ...data.data.error[0] }],
            }, //判定
          });
          return;
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.reportId = reportId;
        this.question_id = data.list[0].question_id;
        this.index = index;

        this.$store.commit('setShowQuestionAnswer', {
          is_confirm: data.list[0].is_confirm,
          get: false,
        });

        this.getQuestionData({
          getAnswer: this.$store.state.questionModeSelect == 2 && data.list[0].is_confirm == 1,
          data,
        });
        resolve();
      });
    },

    async getQuestionData({ getAnswer, data }) {
      if (getAnswer) {
        data = await this.$http.post('/api/app/practice/getOneAnalysis', {
          report_id: this.reportId,
          question_id: this.question_id,
        });
      }

      let ques = Array.isArray(data.list) ? data.list[0] : data;
      if (ques.ques_type != 5 && ques.ques_type != 7 && typeof ques.ques_option === 'string') {
        ques.ques_option = JSON.parse(ques.ques_option);
      }

      ques.index = this.index;
      this.current = ques;
      this.$store.commit('setShowQuestionAnswer', {
        is_confirm: ques.is_confirm,
        get: false,
      });
      this.$emit('topicChange', ques);
    },
    onSubmitTopic({ report_id, question_id, user_answer, answer_time, question }) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        if (question.ques_type == 5) {
          if (
            user_answer != '' ||
            (this.answerImg[question_id] && this.answerImg[question_id].length > 0)
          ) {
            user_answer = JSON.stringify({
              content: user_answer,
              images: this.answerImg[question_id] || [],
            });
          }
        }
        const data = await this.$http.post('/api/app/practice/storeQuestion', {
          report_id: report_id,
          question_id: question_id,
          user_answer: user_answer,
          answer_time: answer_time,
          is_confirm: this.is_confirm.is_confirm,
        });

        if (
          this.$store.state.questionModeSelect == 2 &&
          this.is_confirm.is_confirm == 1 &&
          this.is_confirm.get
        ) {
          this.getQuestionData({ getAnswer: true });
        }
        if (data.code == 203) {
          this.visible = true;
          return;
        }
        resolve();
      });
    },
    async onSubmit({ id, answer_time }) {
      const data = await this.$http.post('/api/app/practice/storeReport', {
        id: id,
        answer_time: answer_time,
      });
      if (data.code == 203) {
        this.visible = true;
        return;
      }
      this.$emit('submit');
    },
    async navNext() {
      this.$refs.right.navNext();
    },
  },
};
</script>
